"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locality = void 0;
const util_1 = require("@app/util");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const react_1 = __importDefault(require("react"));
function Locality({ id, name, shortName, variant = 'both', }) {
    const localities = (0, useWorkspace_1.useWorkspace)()?.localities || [];
    const locality = localities.find((l) => id && l?.id === id);
    const resolvedName = locality?.name || name;
    const resolvedShortName = locality?.shortName || shortName;
    if (!resolvedName && !resolvedShortName) {
        return react_1.default.createElement("div", null, (0, util_1.t)('GLOBAL_NO_LOCALITY'));
    }
    if (variant === 'name' || (!resolvedShortName && resolvedName)) {
        return react_1.default.createElement("div", null, resolvedName);
    }
    if (variant === 'shortName' || (!resolvedName && resolvedShortName)) {
        return react_1.default.createElement("div", null, resolvedShortName);
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("b", null, resolvedShortName),
        " - ",
        resolvedName));
}
exports.Locality = Locality;
